import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFRadio from 'src/components/controls/tempRHFControls/RHFRadio';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';

interface IGenerateBenefitsReportDialogProps {
    dialogName: string;
    benefitYears: Array<number>;
    onSubmit: (year: string, active: string, tsdNo: string) => void;
    hideDialog: () => void;
    selectedTsdNo: number;
    currentYear: number;
}

const GenerateBenefitsReportDialog = (props: IGenerateBenefitsReportDialogProps) => {
    const { register, watch, getValues, setValue } = useForm({
        defaultValues: { year: 'current', active: '', tsdNo: '', specificYear: '' }
    });

    const watchYear = watch('year');
    const watchActive = watch('active');
    const watchTsdNo = watch('tsdNo');

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('GenerateBenefitsReportDialog onCreate()');
    };

    const benefitYearsDropdown = () => {
        return props.benefitYears
            ? props.benefitYears?.map((ct: number) => {
                return { value: ct, label: ct.toString() };
            })
            : [];
    };

    const onSubmit = () => {
        const values = getValues();
        const year = values.year === 'specific' ? values.specificYear : values.year;
        
        props.onSubmit(year, values.active, values.tsdNo);
        props.hideDialog();
    };

    return (
        <Dialog title="Generate Employee Benefits Report" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '50%' }}>
            <div>
                <form>
                    <h3 style={{ color: '#6393C1' }}>Select Year</h3>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 25%)' }}>
                        <RHFRadio
                            name="year"
                            style={{ verticalAlign: 'middle' }}
                            value="current"
                            label={`Current Year ${props.currentYear ? '(' + props.currentYear + ')' : ''}`}
                            register={register}
                            labelOnLeft={true}
                            selected={watchYear === 'current'}
                            onChange={() => setValue('year', 'current')}
                        />
                        <RHFRadio
                            name="year"
                            style={{ verticalAlign: 'middle' }}
                            value="specific"
                            label="Specific Year"
                            register={register}
                            labelOnLeft={true}
                            selected={watchYear === 'specific'}
                            onChange={() => setValue('year', 'specific')}
                        />

                        {watchYear === 'specific' && (
                            <RHFSelect
                                name="specificYear"
                                register={register}
                                label="Year: "
                                options={benefitYearsDropdown()}
                                labelOnLeft={true}
                            />
                        )}
                    </div>

                    <h3 style={{ marginTop: '2rem', color: '#6393C1' }}>Select Employment Status</h3>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 25%)' }}>
                        <RHFRadio
                            name="active"
                            style={{ verticalAlign: 'middle' }}
                            value=""
                            label="All"
                            register={register}
                            labelOnLeft={true}
                            selected={watchActive === ''}
                            onChange={() => setValue('active', '')}
                        />
                        <RHFRadio
                            name="active"
                            style={{ verticalAlign: 'middle' }}
                            value="Y"
                            label="Active"
                            register={register}
                            labelOnLeft={true}
                            selected={watchActive === 'Y'}
                            onChange={() => setValue('active', 'Y')}
                        />
                        <RHFRadio
                            name="active"
                            style={{ verticalAlign: 'middle' }}
                            value="N"
                            label="Inactive"
                            register={register}
                            labelOnLeft={true}
                            selected={watchActive === 'N'}
                            onChange={() => setValue('active', 'N')}
                        />
                    </div>

                    <h3 style={{ marginTop: '2rem', color: '#6393C1' }}>Select Employee</h3>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 25%)' }}>
                        <RHFRadio
                            name="tsdNo"
                            style={{ verticalAlign: 'middle' }}
                            value=""
                            label="All Employees"
                            register={register}
                            labelOnLeft={true}
                            selected={watchTsdNo === ''}
                            onChange={() => setValue('tsdNo', '')}
                        />
                        <RHFRadio
                            name="tsdNo"
                            style={{ verticalAlign: 'middle' }}
                            value={props.selectedTsdNo?.toString()}
                            label="Selected Employee"
                            register={register}
                            labelOnLeft={true}
                            disabled={!props.selectedTsdNo}
                            selected={watchTsdNo === props.selectedTsdNo?.toString() && props.selectedTsdNo?.toString() !== undefined}
                            onChange={() => setValue('tsdNo', props.selectedTsdNo?.toString())}
                        />
                    </div>
                    <div className="form-row" style={{ marginTop: '2rem', marginLeft: '33%', textAlign: 'center' }}>
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Generate Report'}
                            onClick={() => onSubmit()}
                            intent="primary"
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                            intent="secondary"
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default GenerateBenefitsReportDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/benefits/GenerateBenefitsReportDialog.tsx